import React from 'react';
import ImportContainer from '../../common/DataImport/ImportContainer';
import { projectImportConfig } from '../configs/projectImportConfig';

const ImportProjects = () => {
  return (
    <ImportContainer
      config={projectImportConfig}
      title="Import Projects"
      backPath="/data-import"
      backLabel="Back to Data Import"
    />
  );
};

export default ImportProjects; 